import { call, put, takeLatest } from 'redux-saga/effects';
import {
  CREATE_GUEST_PAYER_AND_JWT,
  openPaymentIframe,
} from 'model/palGuestPayment';
import { createGuestPayerAndJwt as createGuestPayerAndJwtApi } from 'util/api';
import { callAction } from '../util';

export function* createGuestPayerAndJwtSaga(callData) {
  const { fspId, loanNumber, accountSuffix, email, assertionBaseUrl } =
    callData;
  return yield call(
    createGuestPayerAndJwtApi,
    fspId,
    loanNumber,
    accountSuffix,
    email,
    assertionBaseUrl
  );
}

const postAction = ({ data, result }) => {
  // Include fspId in result for iframe opening and prefer preloaded baseUrl when provided
  if (result && result.jwt && data.fspId) {
    const assertionBaseUrl = data.assertionBaseUrl || result.assertionBaseUrl;
    return { ...result, fspId: data.fspId, assertionBaseUrl };
  }
  return result;
};

// Handle opening iframe after success
export function* handleSuccess(action) {
  const { data } = action;
  if (data?.jwt && data?.fspId && data?.assertionBaseUrl) {
    yield put(openPaymentIframe(data.jwt, data.fspId, data.assertionBaseUrl));
  }
}

export default function* saga() {
  yield takeLatest(
    CREATE_GUEST_PAYER_AND_JWT.ACTION,
    callAction({
      api: createGuestPayerAndJwtSaga,
      type: CREATE_GUEST_PAYER_AND_JWT,
      postAction,
    })
  );

  yield takeLatest(CREATE_GUEST_PAYER_AND_JWT.SUCCESS, handleSuccess);
}
